import { render, staticRenderFns } from "./arrow_corner-24.vue?vue&type=template&id=a7007366&scoped=true"
import script from "./arrow_corner-24.vue?vue&type=script&lang=js"
export * from "./arrow_corner-24.vue?vue&type=script&lang=js"
import style0 from "./arrow_corner-24.vue?vue&type=style&index=0&id=a7007366&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7007366",
  null
  
)

export default component.exports